import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import SiteFooter from './SiteFooter';
import SiteFooterV2 from '../SiteFooter.new_footer';
export default withFeatureBranch({
    new_footer: SiteFooterV2,
})(SiteFooter);
//# sourceMappingURL=index.js.map